import styled from "@emotion/styled";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import PracticeGrowthLogo from "../images/practice-growth-dashboard-logo.jpg";

export interface HomeImageLinkProps {
  onClick?: () => void;
}

const Img = styled.img`
  width: 30rem;
`;

const HomeImageLink: FC<HomeImageLinkProps> = ({ onClick }) => (
  <Link onClick={onClick} to="/">
    <Img alt="Practice Growth Dashboard" src={PracticeGrowthLogo} />
  </Link>
);

export default HomeImageLink;
